import React, { Component, useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import AddListing from "./AddListing";

//import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';

function AddListingModal(props) {

    const refAddListing = useRef();

    //  let show = props.show;


    /*
    const setShow = (val) => {
        show = val;
    }
    */

    /* {
      state = {
        isOpen: false
      };
     */
    //const openModal = () => setIsOpen(true);  //this.setState({ isOpen: true });
    //const closeModal = () => setIsOpen(props.close);

    //const [isOpen, setIsOpen] = useState(false);

    const handleModalClick = () => {
        //console.log("test");

        if (refAddListing.current) {
            refAddListing.current.submitListing();
        }

    };
    const addedListing = (addList) => {
        if (props.addedListing)
            props.addedListing(addList);
        if (props.close) {
            props.close();
        }
    };

    return (
        <>
            {/* <div className="row">
        <div
          className="align-items-center justify-content-left col-4"
          style={{ height: "5vh" }}
        >
          <Button variant="primary" onClick={openModal}>
            Add Listing
          </Button>
        </div>
        <div className="align-items-center col-8 pt-2 pe-4">
            <p className="text-end ">Need to add a circuit, contact <a href="mailto:listings@sidekick.events">Support</a></p>

        </div>
      </div> */}

            
            <Modal
                className="modal-lg"
                name="listingModal"
                show={props.show}
                //cancel={props.close} 
                onHide={props.close}>
                <Modal.Header closeButton>
                    <Modal.Title>Add / Edit Tournament Listing</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddListing ref={refAddListing} updatedListing={addedListing} /> {/*} close={props.close}/> */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleModalClick}>
                        Save
                    </Button>
                    <Button variant="secondary" onClick={props.close}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AddListingModal;